// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__9kCYI","additionalInfo":"AgreementModal_additionalInfo__2UCMM"};